import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapMutations } = createNamespacedHelpers(
  "notification"
);

export default {
  computed: {
    ...mapState(["paymentDialog", "paymentComplete"])
  },
  methods: {
    ...mapActions(["showMessage", "clearMessage"]),
    ...mapMutations([
      "setAlert",
      "newPaymentSession",
      "updatePaymentDialog",
      "setPaymentComplete"
    ])
  }
};
